
import IconButton from '../icon-button';
import Gutter from '../gutter';
import {
  IconButtonProperty,
  IconButtonPropsEventType,
} from '../icon-button/enums';
import { IconType } from '../icon/enums';
import { GutterProperty } from '../gutter/enums';
import StylesMixin from '../../mixins/styles';
import { Pagination } from './entities/Pagination';

export default {
  name: 'PaginationNavigator',
  components: {
    IconButton,
    Gutter,
  },
  mixins: [StylesMixin],
  props: {
    pagination: {
      required: true,
      type: Pagination,
    },
  },
  data() {
    return {
      IconType,
      IconButtonProperty,
      IconButtonPropsEventType,
      GutterProperty,
    };
  },
  computed: {
    statusText() {
      return this.pagination.pageSize === 1 ? this.singleItemPageStatus : this.multipleItemsPageStatus;
    },
    multipleItemsPageStatus() {
      return `${this.pagination.firstIndexOnPage}-${this.pagination.lastIndexOnPage} of ${this.pagination.totalItems}`;
    },
    singleItemPageStatus() {
      return `${this.pagination.firstIndexOnPage} of ${this.pagination.totalItems}`;
    },
    isLeftArrowDisabled() {
      return this.pagination.firstIndexOnPage === 1;
    },
    isRightArrowDisabled() {
      return this.pagination.lastIndexOnPage === this.pagination.totalItems;
    },
  },
  methods: {
    handleLeftArrowButtonClick() {
      if (this.isLeftArrowDisabled) {
        return;
      }

      this.pagination.setPreviousPage();
      this.emitChange();
    },
    handleRightArrowButtonClick() {
      if (this.isRightArrowDisabled) {
        return;
      }

      this.pagination.setNextPage();
      this.emitChange();
    },
    emitChange() {
      this.$emit('change', this.pagination.options);
    },
  },
};
